import React, { FunctionComponent, useState } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import SearchIcon from '@uniiverse/library/assets/icons/new-search.svg'
import { gotoTagSearch } from 'src/lib/navigate-to'

import { locale } from './locale'

const style = require('./SearchBar.css')

interface Props {
  isMobile?: boolean;
}

const SearchBarComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  isMobile = false,
  intl,
}) => {
  const [value, setValue] = useState('')

  const handleSubmit = (event) => {
    event.preventDefault()
    gotoTagSearch(value)
  }

  return (
    <div className={style.search}>
      <form className={style.searchInputContainer} onSubmit={event => handleSubmit(event)}>
        <input
          className={`${isMobile ? style.mobileSearch : style.desktopSearch}`}
          value={value}
          onChange={event => setValue(event.target.value)}
          placeholder={intl.formatMessage(locale.searchEvents)}
        />
        <button
          aria-label="search"
          type="submit"
          className={`${style.searchIcon} ${style.searchButton}`}
        >
          <SearchIcon />
        </button>
      </form>
    </div>
  )
}

export const SearchBar = injectIntl(SearchBarComponent)
